import { useProducts } from './use-products';
import { Button } from '@ui/buttons/button';
import { Trans } from '@ui/i18n/trans';
import { ForumIcon } from '@ui/icons/material/Forum';
import { Navbar } from '../../ui/navigation/navbar/navbar';
import { Link } from 'react-router-dom';
import { Footer } from '../../ui/footer/footer';
import { Fragment, useState } from 'react';
import { UpsellBillingCycle } from './find-best-price';
import { BillingCycleRadio } from './billing-cycle-radio';
import { StaticPageTitle } from '../../seo/static-page-title';
import { PricingTable } from '@common/billing/pricing-table/pricing-table';

export function PricingPage() {
  const query = useProducts('pricingPage');
  const [selectedCycle, setSelectedCycle] =
    useState<UpsellBillingCycle>('year');

  return (
    <Fragment>
      <div
      className="flex min-h-screen flex-col bg-alt"
      style={{
        backgroundImage: "url('/images/LandingImg/ctamask.png')",
      }}
    >
      <StaticPageTitle>
        <Trans message="Pricing" />
      </StaticPageTitle>
      <Navbar
        color="transparent"
        className="fixed top-0 sticky z-50 w-full flex-shrink-0 border-none shadow-lg"
        menuPosition="pricing-table-page"
      />
      <div className="landing-container font-archivo mx-auto ">
      <h1 className=" text-center text-3xl font-semibold mt-20 md:mt-60 md:text-4xl">
        Proudly <span style={{color: '#00c5ff'}}>Made in India,</span><br />
        Built for Your <span style={{color: '#00c5ff'}}>Data's Safety</span>
      </h1>

        <p className="mt-10 text-center text-xl"><Trans message="Affordable, Secure, 100% Indian Cloud Storage for Everyone."/></p>
        {/* <p className="mt-20 mb-40 text-center text-xl"><span className="font-semibold">"Save up to 91% with Spacebyte</span> - secure, india-based cloud storage."</p> */}
        <div className="flex justify-center mt-20 mb-40">
        <p
          className="text-center text-xl"
          style={{
            border: '1px solid rgba(222, 209, 209, 0.1)', // soft light border
            backgroundColor: 'rgba(255, 255, 255, 0.05)', // soft light background
            borderRadius: '8px',                    // rounded corners
            padding: '10px',                        // inner spacing
            display: 'inline-block',      
          }}
        >
          <span className="font-bold">
            <span style={{color: '#00c5ff'}}>Save up to 92% with SpaceByte</span> 
          </span>{" "}
          - Secure, India based cloud storage.
        </p>
        </div>

        <div className="text-white flex flex-col md:flex-row justify-center items-center w-full mt-6 gap-20">
        <BillingCycleRadio
          products={query.data?.products}
          selectedCycle={selectedCycle}
          onChange={setSelectedCycle}
          className="input-radio flex justify-center"
          size="lg"
        />
        </div>
        
        <PricingTable
          selectedCycle={selectedCycle}
          productLoader="pricingPage"
        />
       <CommunitySection />
      <ContactSection />
     
      </div>
      <Footer className="container mx-auto flex-shrink-0 px-24" />
      </div>
    </Fragment>
  );
}

export function ContactSection() {
  return (
    <div className="my-10 p-24 text-center md:my-50">
      <ForumIcon size="xl" className="text-muted" />
      <div className="font-archivo my-8 font-medium md:text-xl">
        <Trans message="Do you have any questions about PRO accounts?" />
      </div>
      <div className="font-inter mb-24 mt-20 text-sm md:mt-0 md:text-base">
        <Trans message="Our support team will be happy to assist you." />
      </div>
      <Button className="btn-warning h-auto" elementType={Link} to="/contact">
        <Trans message="Contact Us" />
      </Button>
    </div>
  );
}
 
export function CommunitySection() {
  return (
    <section className="Community-section relative overflow-hidden py-40 lg:py-100">
      {/* Container */}
      <div
        className="landing-container relative z-10 space-y-8 bg-contain bg-center bg-no-repeat py-0 text-center lg:py-80"
        style={{ backgroundImage: "url('/images/LandingImg/map.png')" }}
      >
        <div className="mx-auto max-w-xl space-y-16 text-center">
          {/* Title */}
          <h2 className="animate-fade-down font-archivo text-3xl md:text-3xl lg:text-3xl text-primary dark:text-white">
            At <span className="color-primary-gradient">SpaceByte</span>, we believe
          </h2>

          <h2 className="font-inter animate-fade-down mx-auto text-3xl font-bold md:text-4xl lg:text-4xl text-primary dark:text-white">
            Your Data, Your Control
          </h2>

          {/* Description */}
          <p className="font-inter animate-fade-down mx-auto text-muted dark:text-muted-light">
            We use bank-grade encryption so even we can't access your files
            <br />
            <br />
            Store smarter. Store safer. Store Indian.
          </p>

          {/* Button */}
          <div className="flex justify-center">
            <Button className="btn-warning h-auto" elementType={Link} to="/register">
              Get Started
            </Button>
          </div>
        </div>
      </div>

      {/* Icons (Decorative) */}
      <div className="absolute left-12 top-80 hidden md:left-40 md:block lg:left-160">
        <img
          src="/images/LandingImg/facebook-element.png"
          alt="Facebook"
          className="w-16 md:w-24 lg:w-auto"
        />
      </div>
      <div className="absolute bottom-80 left-12 hidden md:left-64 md:block lg:left-200">
        <img
          src="/images/LandingImg/chat-elements.png"
          alt="Chat"
          className="w-16 md:w-24 lg:w-auto"
        />
      </div>
      <div className="absolute right-12 top-60 hidden md:right-40 md:block lg:right-160">
        <img
          src="/images/LandingImg/bell-elements.png"
          alt="Notification Bell"
          className="w-16 md:w-32 lg:w-auto"
        />
      </div>
      <div className="absolute bottom-100 right-12 hidden md:right-64 md:block lg:right-200">
        <img
          src="/images/LandingImg/facebook-element.png"
          alt="Facebook"
          className="w-16 md:w-24 lg:w-auto"
        />
      </div>
    </section>
  );
}